export let baseImgUrl =
    process.env.NODE_ENV == "development" ? "https://img.telllead.com/asset/" : "https://img.telllead.com/asset/"


